import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import pusherService from "./pusherService";

/**
 * On login: opens Pusher WebSocket and subscribes to `{accountId}-{userId}` channel.
 * On logout: channel + connection are torn down via signOutGlobally → disconnect().
 */
const PusherConnectionProvider = ({ children }) => {
  const accountId = useSelector((state) => state.auth.user.accountId);
  const userId = useSelector((state) => state.auth.user.userId);

  useEffect(() => {
    if (accountId == null || userId == null) {
      return undefined;
    }

    pusherService.connect(Number(accountId), Number(userId));

    return undefined;
  }, [accountId, userId]);

  return children;
};

export default PusherConnectionProvider;
